(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-carousel-showcase"] && !Shopify.designMode) return;
  try {
    
  class ImageCarouselShowcase extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ics-track]');
      this.viewport = this.querySelector('[data-ics-viewport]');
      if (!this.track || !this.viewport) return;
      this.prevBtn = this.querySelector('[data-ics-prev]');
      this.nextBtn = this.querySelector('[data-ics-next]');
      this.dots = Array.from(this.querySelectorAll('[data-ics-dot]'));
      this.cards = Array.from(this.track.children);
      this.index = 0;
      this.autoplay = this.hasAttribute('data-autoplay');
      this.speed = (parseFloat(this.getAttribute('data-speed')) || 4) * 1000;
      this.loop = this.hasAttribute('data-loop');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._bind();
      this._update();
      this._initGalleries();
      if (this.hasAttribute('data-entrance') && !this.reduced && 'IntersectionObserver' in window) {
        this.cards.forEach((c) => { c.style.opacity = '0'; c.style.transform = 'translateY(18px)'; c.style.transition = 'opacity .6s cubic-bezier(.2,.8,.2,1), transform .6s cubic-bezier(.2,.8,.2,1)'; });
        var reveal = () => { this.cards.forEach((c, i) => { setTimeout(() => { c.style.opacity = '1'; c.style.transform = 'none'; }, i * 70); }); };
        this._io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { reveal(); if (this._io) { this._io.disconnect(); this._io = null; } if (this._failTimer) { clearTimeout(this._failTimer); this._failTimer = null; } } }); }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
        this._io.observe(this);
        this._failTimer = setTimeout(() => { reveal(); if (this._io) { this._io.disconnect(); this._io = null; } }, 1800);
      }
      if (this.autoplay && !this.reduced) this._play();
    }
    disconnectedCallback() { this._stop(); if (this._raf) cancelAnimationFrame(this._raf); if (this._raf2) cancelAnimationFrame(this._raf2); if (this._onMove) window.removeEventListener('pointermove', this._onMove); if (this._onUp) window.removeEventListener('pointerup', this._onUp); if (this._io) this._io.disconnect(); if (this._failTimer) clearTimeout(this._failTimer); }

    _padL() { return parseFloat(getComputedStyle(this.track).paddingLeft) || 0; }
    _gap() { var cs = getComputedStyle(this.track); return parseFloat(cs.columnGap || cs.gap) || 0; }
    _step() { var w = this.cards[0] ? this.cards[0].offsetWidth : 300; return w + this._gap(); }
    _maxScroll() { return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth); }
    _restLeft(i) { var c = this.cards[i]; if (!c) return 0; return Math.max(0, Math.min(c.offsetLeft - this._padL(), this._maxScroll())); }
    _active() { var sl = this.viewport.scrollLeft, padL = this._padL(), best = 0, bd = Infinity; for (var i = 0; i < this.cards.length; i++) { var d = Math.abs((this.cards[i].offsetLeft - padL) - sl); if (d < bd) { bd = d; best = i; } } return best; }
    _scrollTo(left) {
      // Concept/Tailwind theme reverts any multi-frame / animated scroll on these elements
      // (browser smooth-scroll, rAF tweens, CSS-transitioned offsets all snap back to 0),
      // but a single discrete write sticks. So arrows/dots jump instantly; native touch and
      // trackpad swipe stay smooth on their own + scroll-snap keeps them card-aligned.
      this.viewport.scrollLeft = Math.max(0, Math.min(left, this._maxScroll()));
    }

    _bind() {
      var self = this;
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self._stop(); self._move(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self._stop(); self._move(1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self._stop(); self._goto(i); }); });
      this.viewport.addEventListener('scroll', function () { if (self._raf) return; self._raf = requestAnimationFrame(function () { self._raf = null; self._update(); }); }, { passive: true });
      this._onResize = function () { self._update(); }; window.addEventListener('resize', this._onResize);
      this.addEventListener('pointerenter', function () { self._stop(); });
      this.addEventListener('pointerleave', function () { if (self.autoplay && !self.reduced) self._play(); });
      // desktop click-drag to scroll (touch devices use native momentum scrolling)
      this._drag = null;
      this.viewport.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; if (e.target.closest('[data-ics-gallery]')) return; self._stop(); self._drag = { x: e.clientX, sl: self.viewport.scrollLeft, moved: false }; self.viewport.classList.add('is-dragging'); });
      this._onMove = function (e) { if (!self._drag) return; var dx = e.clientX - self._drag.x; if (Math.abs(dx) > 4) self._drag.moved = true; self.viewport.scrollLeft = self._drag.sl - dx; };
      this._onUp = function () { if (!self._drag) return; var moved = self._drag.moved; self._drag = null; self.viewport.classList.remove('is-dragging'); if (moved) { self._suppress = true; self._goto(self._active()); } if (self.autoplay && !self.reduced) self._play(); };
      window.addEventListener('pointermove', this._onMove);
      window.addEventListener('pointerup', this._onUp);
      this.viewport.addEventListener('click', function (e) { if (self._suppress) { e.preventDefault(); e.stopPropagation(); self._suppress = false; } }, true);
    }
    _initGalleries() {
      var self = this;
      var gals = Array.from(this.querySelectorAll('[data-ics-gallery]'));
      gals.forEach(function (g) {
        var slides = Array.from(g.children);
        var dotsWrap = g.parentElement.querySelector('[data-ics-gdots]');
        var dots = dotsWrap ? Array.from(dotsWrap.children) : [];
        function nearest() { var sl = g.scrollLeft, best = 0, bd = Infinity; for (var i = 0; i < slides.length; i++) { var dd = Math.abs(slides[i].offsetLeft - sl); if (dd < bd) { bd = dd; best = i; } } return best; }
        dots.forEach(function (d, i) { d.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); if (slides[i]) g.scrollLeft = slides[i].offsetLeft; }); });
        var raf = null;
        g.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; var a = nearest(); for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === a); }); }, { passive: true });
        // desktop click-drag to swipe (native overflow scrollers don't mouse-drag); touch/trackpad swipe is native.
        // at the gallery's edge the extra drag CHAINS to the parent rail (matches the native touch overscroll).
        var drag = null, suppress = false;
        g.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; drag = { x: e.clientX, sl: g.scrollLeft, pv: self.viewport.scrollLeft, moved: false, chained: false }; self.viewport.classList.add('is-dragging'); try { g.setPointerCapture(e.pointerId); } catch (err) {} });
        g.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true; var want = drag.sl - dx, gmax = Math.max(0, g.scrollWidth - g.clientWidth); if (want > gmax) { g.scrollLeft = gmax; self.viewport.scrollLeft = drag.pv + (want - gmax); drag.chained = true; } else if (want < 0) { g.scrollLeft = 0; self.viewport.scrollLeft = drag.pv + want; drag.chained = true; } else { g.scrollLeft = want; } });
        var end = function (e) { if (!drag) return; suppress = drag.moved; var chained = drag.chained; drag = null; self.viewport.classList.remove('is-dragging'); try { g.releasePointerCapture(e.pointerId); } catch (err) {} if (suppress && !chained && slides[nearest()]) g.scrollLeft = slides[nearest()].offsetLeft; if (chained) self._goto(self._active()); };
        g.addEventListener('pointerup', end);
        g.addEventListener('pointercancel', end);
        g.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; } }, true);
        // trackpad / mouse-wheel: native nested scroll won't chain, so when the gallery is at its
        // edge we forward the horizontal scroll to the parent rail (smooth, then snap to a card).
        g.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical → let the page scroll
          var gmax = Math.max(0, g.scrollWidth - g.clientWidth);
          var atEnd = g.scrollLeft >= gmax - 2, atStart = g.scrollLeft <= 2;
          if ((e.deltaX > 0 && atEnd) || (e.deltaX < 0 && atStart)) {
            e.preventDefault();
            self.viewport.classList.add('is-dragging');
            self.viewport.scrollLeft += e.deltaX;
            clearTimeout(self._chainT);
            self._chainT = setTimeout(function () { self.viewport.classList.remove('is-dragging'); self._goto(self._active()); }, 150);
          }
        }, { passive: false });
      });
    }
    _move(dir) {
      var i = this._active() + dir, last = this.cards.length - 1;
      if (i < 0) i = this.loop ? last : 0;
      else if (i > last) i = this.loop ? 0 : last;
      else if (this.loop && dir > 0 && this.viewport.scrollLeft >= this._maxScroll() - 2) i = 0;
      this._goto(i);
    }
    _goto(i) { i = Math.max(0, Math.min(this.cards.length - 1, i)); this.index = i; this._scrollTo(this._restLeft(i)); this._update(); }
    _update() {
      var a = this._active(), sl = this.viewport.scrollLeft, max = this._maxScroll();
      this.dots.forEach(function (d, di) { var on = di === a; d.classList.toggle('is-active', on); d.setAttribute('aria-current', on ? 'true' : 'false'); });
      if (this.prevBtn && !this.loop) this.prevBtn.toggleAttribute('disabled', sl <= 2);
      if (this.nextBtn && !this.loop) this.nextBtn.toggleAttribute('disabled', sl >= max - 2);
    }
    _play() { var self = this; this._stop(); this._timer = setInterval(function () { if (self.viewport.scrollLeft >= self._maxScroll() - 2) { if (self.loop) self._goto(0); else self._stop(); } else self._move(1); }, this.speed); }
    _stop() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
  }
  if (!customElements.get('image-carousel-showcase')) customElements.define('image-carousel-showcase', ImageCarouselShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skrt-announcement-bar-2"] && !Shopify.designMode) return;
  try {
    
  /* ═══ <skrt-announcement-bar> · root web component ═══ */
  if (!customElements.get('skrt-announcement-bar')) {
    customElements.define('skrt-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;

        if (this.dataset.dismissible === 'true') {
          try {
            if (localStorage.getItem('skrt-ab-dismissed-' + sectionId) === 'true') {
              this.hidden = true;
              return;
            }
          } catch (e) { /* storage may be blocked; treat as visible */ }

          const dismissBtn = this.querySelector('[data-skrt-dismiss]');
          if (dismissBtn) {
            dismissBtn.addEventListener('click', () => {
              this.hidden = true;
              try { localStorage.setItem('skrt-ab-dismissed-' + sectionId, 'true'); } catch (e) {}
            });
          }
        }

        /* Carousel autoplay */
        const carousel = this.querySelector('.skrt-ab-carousel');
        if (carousel && carousel.dataset.autoplay === 'true') {
          this._initCarousel(carousel);
        }

        /* Marquee duration calculated from content width, recomputed on resize */
        const marqueeTrack = this.querySelector('.skrt-ab-marquee-track');
        if (marqueeTrack) {
          const speed = parseFloat(this.dataset.marqueeSpeed) || 20;
          const computeMarquee = () => {
            const seconds = (marqueeTrack.scrollWidth / 1000) * speed;
            marqueeTrack.style.setProperty('--marquee-time', seconds.toFixed(1) + 's');
          };
          /* Defer until layout/fonts settle */
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => requestAnimationFrame(computeMarquee));
          } else {
            requestAnimationFrame(computeMarquee);
          }
          /* Recompute on viewport resize so the animation speed stays consistent */
          if ('ResizeObserver' in window) {
            this._marqueeObserver = new ResizeObserver(() => computeMarquee());
            this._marqueeObserver.observe(marqueeTrack);
          }
        }
      }

      disconnectedCallback() {
        this._clearCarousel();
        if (this._marqueeObserver) {
          this._marqueeObserver.disconnect();
          this._marqueeObserver = null;
        }
      }

      _initCarousel(carousel) {
        const slides = carousel.querySelectorAll('.skrt-ab-carousel__slide');
        if (slides.length <= 1) return;
        const interval = parseInt(carousel.dataset.interval, 10) || 5000;
        const mode = carousel.dataset.mode || 'fade';
        const exitMs = 650;  // matches CSS transition + small buffer
        let current = 0;
        let userPaused = false;

        /* advance(direction = 'forward')
           Direction controls which way the swipe flows:
             'forward'  — new slide enters from RIGHT, old exits LEFT (default)
             'backward' — new slide enters from LEFT,  old exits RIGHT
                          (used when user swipes right to go back)
           CSS variables on the carousel drive the visual direction; the
           three-state class machine stays the same. */
        const advance = (direction) => {
          direction = direction || 'forward';
          const prev = current;
          if (direction === 'forward') {
            current = (current + 1) % slides.length;
            carousel.style.setProperty('--enter-from', '100%');
            carousel.style.setProperty('--leave-to',  '-100%');
          } else {
            current = (current - 1 + slides.length) % slides.length;
            carousel.style.setProperty('--enter-from', '-100%');
            carousel.style.setProperty('--leave-to',  '100%');
          }

          if (mode === 'slide') {
            slides[prev].classList.add('skrt-ab-carousel__slide--leaving');
            slides[prev].classList.remove('skrt-ab-carousel__slide--active');
            slides[current].classList.add('skrt-ab-carousel__slide--active');
            setTimeout(() => {
              slides[prev].classList.remove('skrt-ab-carousel__slide--leaving');
            }, exitMs);
          } else {
            slides[prev].classList.remove('skrt-ab-carousel__slide--active');
            slides[current].classList.add('skrt-ab-carousel__slide--active');
          }
        };

        /* Touch / gesture handlers — only meaningful for slide mode, but
           safe to attach in fade mode too (it'll just advance the slide).

           Gesture model:
             · Horizontal drag (>40px in <800ms) → advance forward/backward
             · Vertical drag (|dy| > |dx|) → ignored (let page scroll)
             · Tap (|dx| < 10px, dt < 200ms) → toggle pause/play
             · Auto-rotation pauses during touch, resumes on release (unless
               user explicitly tapped to pause). */
        let touchStartX = 0;
        let touchStartY = 0;
        let touchStartT = 0;
        let touchActive = false;

        carousel.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartT = Date.now();
          touchActive = true;
          this._clearCarousel();  // pause auto-rotation while touched
        }, { passive: true });

        carousel.addEventListener('touchend', (e) => {
          if (!touchActive) return;
          touchActive = false;
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          const dt = Date.now() - touchStartT;

          // Resume gate: re-arm auto-rotation unless user paused
          const resume = () => { if (!userPaused) this._startCarousel(); };

          // Vertical-dominant or too-slow gesture → not a swipe
          if (Math.abs(dy) > Math.abs(dx) || dt > 800) {
            resume();
            return;
          }

          // Tap (small movement, quick): toggle pause state
          if (Math.abs(dx) < 10 && dt < 200) {
            userPaused = !userPaused;
            if (userPaused) this._clearCarousel();
            else this._startCarousel();
            return;
          }

          // Horizontal swipe: ≥40px in dx
          if (dx <= -40) {
            advance('forward');   // dragged left → next slide
          } else if (dx >= 40) {
            advance('backward');  // dragged right → previous slide
          }
          resume();
        }, { passive: true });

        // Cancel handles edge cases (interrupted touch, multi-finger, etc.)
        carousel.addEventListener('touchcancel', () => {
          touchActive = false;
          if (!userPaused) this._startCarousel();
        }, { passive: true });

        this._startCarousel = () => {
          this._clearCarousel();
          this._carouselTimer = setInterval(advance, interval);
        };

        this._startCarousel();

        /* Pause on hover, resume on leave (desktop). Respects userPaused so
           a tap-to-pause sticks even if a mouseleave fires (some mobile
           browsers emit synthetic mouse events alongside touch). */
        carousel.addEventListener('mouseenter', () => this._clearCarousel());
        carousel.addEventListener('mouseleave', () => {
          if (!userPaused) this._startCarousel();
        });

        /* Respect reduced-motion preference */
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (mq.matches) this._clearCarousel();
        mq.addEventListener('change', (e) => {
          if (e.matches) this._clearCarousel();
          else this._startCarousel();
        });
      }

      _clearCarousel() {
        if (this._carouselTimer) {
          clearInterval(this._carouselTimer);
          this._carouselTimer = null;
        }
      }
    });
  }

  /* ═══ <skrt-countdown-timer> ═══ */
  if (!customElements.get('skrt-countdown-timer')) {
    customElements.define('skrt-countdown-timer', class extends HTMLElement {
      connectedCallback() {
        /* First-time-only targeting (3-layer detection) */
        if (this.dataset.firstTimeOnly === 'true') {
          let lsVisited = false;
          try { lsVisited = localStorage.getItem('skrt_visited') === 'true'; } catch (e) {}
          const ckVisited = document.cookie.indexOf('skrt_visited=true') !== -1;
          if (lsVisited || ckVisited) {
            this.hidden = true;
            return;
          }
          try { localStorage.setItem('skrt_visited', 'true'); } catch (e) {}
          document.cookie = 'skrt_visited=true; path=/; max-age=' + (365 * 86400) + '; SameSite=Lax';
        }

        const mode = this.dataset.mode || 'fixed';
        let expiry;

        if (mode === 'local') {
          const tH = parseInt(this.dataset.hour, 10) || 0;
          const tM = parseInt(this.dataset.minute, 10) || 0;
          const now = new Date();
          const t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), tH, tM, 0);
          if (t.getTime() <= now.getTime()) t.setDate(t.getDate() + 1);
          expiry = t.getTime();
        } else {
          const dateParts = (this.dataset.endDate || '2026-12-31').split('-');
          const timeParts = (this.dataset.endTime || '23:59').split(':');
          const tzOff = parseFloat(this.dataset.tzOffset || '0');
          expiry = Date.UTC(
            parseInt(dateParts[0], 10),
            parseInt(dateParts[1], 10) - 1,
            parseInt(dateParts[2], 10),
            parseInt(timeParts[0], 10) || 0,
            parseInt(timeParts[1], 10) || 0,
            0
          ) - (tzOff * 3600000);
        }

        const dEl = this.querySelector('[data-days]');
        const hEl = this.querySelector('[data-hours]');
        const mEl = this.querySelector('[data-minutes]');
        const sEl = this.querySelector('[data-seconds]');

        const pad = (n) => String(n).padStart(2, '0');

        const tick = () => {
          const d = expiry - Date.now();
          if (d < 0) {
            this.hidden = true;
            this._clearTimer();
            this.dispatchEvent(new CustomEvent('skrt:countdown-expired', { bubbles: true }));
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(d / 86400000));
          if (hEl) hEl.textContent = pad(Math.floor((d % 86400000) / 3600000));
          if (mEl) mEl.textContent = pad(Math.floor((d % 3600000) / 60000));
          if (sEl) sEl.textContent = pad(Math.floor((d % 60000) / 1000));
        };
        tick();
        this._timer = setInterval(tick, 1000);
      }

      disconnectedCallback() {
        this._clearTimer();
      }

      _clearTimer() {
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
      }
    });
  }

  /* ═══ <skrt-promo-code> · clipboard copy with fallback ═══ */
  if (!customElements.get('skrt-promo-code')) {
    customElements.define('skrt-promo-code', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('.skrt-promo-btn');
        if (!btn) return;
        const code = this.dataset.code || '';
        const redirect = this.dataset.redirect || '';

        const fallbackCopy = (text) => {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          let ok = false;
          try { ok = document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          return ok;
        };

        btn.addEventListener('click', async () => {
          let copied = false;
          if (navigator.clipboard && window.isSecureContext) {
            try {
              await navigator.clipboard.writeText(code);
              copied = true;
            } catch (e) {
              copied = fallbackCopy(code);
            }
          } else {
            copied = fallbackCopy(code);
          }

          btn.dataset.copied = copied ? 'true' : 'error';
          this._copyResetTimer = setTimeout(() => {
            btn.dataset.copied = 'false';
          }, 2000);

          if (copied && redirect) {
            this._redirectTimer = setTimeout(() => { window.location.href = redirect; }, 1500);
          }
        });
      }

      disconnectedCallback() {
        if (this._copyResetTimer) clearTimeout(this._copyResetTimer);
        if (this._redirectTimer)  clearTimeout(this._redirectTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
